import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

function Navigation() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const handleSignOut = async () => {
    await supabase.auth.signOut();
    window.location.reload();
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const navigationItems = [
    { path: '/', label: 'Dashboard' },
    { path: '/habits', label: 'Habits' },
    { path: '/life-in-weeks', label: 'Life in Weeks' },
  ];

  return (
    <nav className="bg-white shadow-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img 
                  src="https://gckvitd1qe.ufs.sh/f/IjvP5MdEoCL2wk9k9OYEOIcNHVeSo6TlRb7BLM1sqDdrm0PU" 
                  alt="PlantAhead Logo" 
                  className="h-10 w-10"
                />
                <span className="text-xl font-semibold text-gray-900">PlantAhead</span>
              </Link>
            </div>
            <div className="hidden sm:ml-10 sm:flex sm:space-x-8">
              {navigationItems.map(({ path, label }) => (
                <Link
                  key={path}
                  to={path}
                  className={`inline-flex items-center px-1 pt-1 text-sm font-medium transition-colors ${
                    isActive(path) 
                      ? 'text-primary-600 border-b-2 border-primary-600' 
                      : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent'
                  }`}
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>
          <div className="flex items-center">
            <button
              onClick={handleSignOut}
              className="hidden sm:block text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors"
            >
              Sign Out
            </button>
            <div className="sm:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
              >
                <span className="sr-only">Open main menu</span>
                {isMobileMenuOpen ? (
                  <XMarkIcon className="block h-6 w-6" />
                ) : (
                  <Bars3Icon className="block h-6 w-6" />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`sm:hidden ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
        <div className="pt-2 pb-3 space-y-1">
          {navigationItems.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block pl-3 pr-4 py-2 text-base font-medium transition-colors ${
                isActive(path)
                  ? 'text-primary-600 bg-primary-50 border-l-4 border-primary-500'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700 border-l-4 border-transparent'
              }`}
            >
              {label}
            </Link>
          ))}
          <button
            onClick={() => {
              setIsMobileMenuOpen(false);
              handleSignOut();
            }}
            className="block w-full text-left pl-3 pr-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-700 border-l-4 border-transparent"
          >
            Sign Out
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;